"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _helpers = require("react-platform-components/dist/helpers");
var _index = require("../config/index");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var NavItem = /*#__PURE__*/function (_React$Component) {
  _inherits(NavItem, _React$Component);
  var _super = _createSuper(NavItem);
  function NavItem() {
    _classCallCheck(this, NavItem);
    return _super.apply(this, arguments);
  }
  _createClass(NavItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        item = _this$props.item,
        selected = _this$props.selected,
        toggleDrawer = _this$props.toggleDrawer;
      return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
        style: {
          height: "40px"
        },
        button: true,
        key: item.id,
        component: item.component ? item.component : _reactRouterDom.Link,
        to: item.type === "local" ? "/".concat(item.url) : item.url,
        href: item.url,
        target: item.target ? item.target : "_self",
        onClick: function onClick(event) {
          return toggleDrawer && toggleDrawer(event);
        },
        selected: selected
      }, item.icon && !item.iconComponent && /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
        style: {
          minWidth: '42px'
        }
      }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, item.icon)), item.external_icon && /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, null, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          height: "1em",
          width: "1em"
        },
        src: (0, _helpers.joinPaths)(_index.BASE_URL, item.external_icon_url),
        alt: item.type
      })), item.iconComponent && /*#__PURE__*/_react.default.createElement(_core.ListItemIcon, {
        style: {
          minWidth: '42px'
        }
      }, item.iconComponent), /*#__PURE__*/_react.default.createElement(_core.ListItemText, {
        primary: item.title,
        primaryTypographyProps: {
          style: {
            fontSize: '14px'
          }
        }
      }));
    }
  }]);
  return NavItem;
}(_react.default.Component);
NavItem.propTypes = {
  item: _propTypes.default.object.isRequired
};
var _default = NavItem;
exports.default = _default;